import React from 'react'

const Pgssearchskeleton = () => {
  return (
    <>
      <div className='max-w-container mx-auto'>
        <div className='relative z-3 md:mt-[-28px] '>
        <div className="flex flex-col gap-[24px] min-h-[60px]">
          <div className="bg-white rounded-[32px] p-[16px] border border-grey600 shadow-custom-1 md:pl-[24px] md:p-[10px]">
            <div className="flex flex-col items-stretch md:flex-row md:items-center">
              <div className="relative mb-[24px] md:mb-[0] shrink-0 flex-1">
                <div className="skeleton skeleton-text skeleton-text-animated descript mr-0 w-full md:w-[40%] md:mr-[16px]"></div>
              </div>
              <div className="pt-[2px] md:pt-[0]">
                <div className="skeleton skeleton_btn skeleton-text-animated w-full  px-[24px] py-[10px] md:min-w-[114px] !my-0"></div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </>
  )
}

export default Pgssearchskeleton;